import {h, Component, Fragment} from "preact";
import {route} from "preact-router";
import {TicketHeader, TicketBody, EndedTicketPopups} from "../mobile-pages/ticket-ltn.jsx";
import Page from "../../../services/page-data-feed"

import FullSite from "./full-site";

import * as M from "../desktop-templates/prematch-menu.jsx";
import * as T from "../desktop-templates/prematch-right-col.jsx";
import * as L from "../desktop-templates/live-general.jsx";
import * as I from "../utils/icons";

import MenuFull from "../desktop-components/menu-full.jsx";
import {MenuSportsOnly} from "../desktop-components/menu-sports-only.jsx";
import MenuTopleagues from "../desktop-components/menu-topleagues.jsx";
import MenuSearchEvent from "../desktop-components/menu-search-event.jsx";
import MenuBetServices from "../desktop-components/menu-bet-services.jsx";
import MenuTimeFilter from "../desktop-components/menu-time-filter.jsx";

import PrematchEventContent from "../desktop-components/prematch-event.jsx";

import TicketCheckBet from "../desktop-components/ticket-check-bet.jsx";
import TicketLoadBet, { TicketLoadCashier } from "../desktop-components/ticket-load-bet.jsx";
import TicketFastBet from "../desktop-components/ticket-fast-bet.jsx";

import MobilePrematchEvent from "../mobile-pages/prematch-event.jsx";

export default function PrematchEvent({sportId, categoryId, tournamentId, eventId}) {
	return <FullSite><PrematchEventTemplate {...{sportId, categoryId, tournamentId, eventId}} /></FullSite>;
}


export function PrematchEventTemplate({sportId, categoryId, tournamentId, eventId}) {
	return <div class="font-roboto">
		<L.TopRowContainer>
			<L.ContainerLink>
				<L.TopPageLink href="/prematch">Sport Home</L.TopPageLink>
				<L.TopPageLink href="/live">Live</L.TopPageLink>
			</L.ContainerLink>
		</L.TopRowContainer>
		<div class="flex border-b border-b-harifzinc-950 bg-harifzinc-900 text-white">
			<div class="scrollbar-fancy w-72 flex-none overflow-y-scroll border-r border-r-harifzinc-950">
				<M.MenuRow>
					<M.MenuTitleLabel>Sports Menu</M.MenuTitleLabel>
					<M.MenuCollapseBtnHolder><I.AnglesLeft class="h-4"/></M.MenuCollapseBtnHolder>
				</M.MenuRow>
				<MenuTopleagues callback={item => {
					Page.openTournaments([item.id]);
					route("/prematch")
				}}/>
				<a class="flex h-8 items-center border-b border-b-harifzinc-950 bg-harifzinc-800 hover:bg-harifzinc-700 text-white"
				   href="/live">
					<M.MenuTitleCenteredLabel>
						<I.StopwatchRegular class="h-3 mr-1"/> <span>IN-PLAY</span>
					</M.MenuTitleCenteredLabel>
				</a>
				<MenuTimeFilter/>
				<MenuSearchEvent/>
				<MenuFull onTournamentOpen={e => route("/prematch")}/>
				<M.BlankSeparator/>
				<MenuBetServices/>
			</div>
			<div class="scrollbar-fancy min-w-0 grow overflow-y-scroll border-r border-r-harifzinc-950">
				<PrematchEventContent key={eventId} {...{sportId, categoryId, tournamentId, eventId}} />
			</div>
			<div class="scrollbar-fancy w-72 flex-none overflow-y-scroll border-r border-r-harifzinc-950">
				<TicketFastBet/>
				<T.ColumnTicketWrappper>
					<T.TicketTopRow>
						<TicketHeader/>
					</T.TicketTopRow>
					<TicketBody/>
					<EndedTicketPopups/>
				</T.ColumnTicketWrappper>
				<M.BlankSeparator/>
				<TicketLoadBet/>
				<M.BlankSeparator/>
				<TicketCheckBet/>
				<M.BlankSeparator />
				<TicketLoadCashier />
			</div>
		</div>
	</div>
}





